import { mapState } from 'vuex'
import maModal from '@/components/modal'
import maSmModal from './components/smDevModal'
import maLoader from '@/components/loader'
import maNotifications from '@/components/notifications'
import routesBuilderMixin from '@/mixins/authRoutesBuilder'
import { USER_MODULE_NAME } from '@/store/types'
import * as Settings from '@/infra/settings'
import * as GoogleMaps from '@/infra/googleMaps'

export default {
  name: 'App',
  mixins: [routesBuilderMixin],
  components: {
    maModal,
    maSmModal,
    maLoader,
    maNotifications
  },
  computed: {
    ...mapState({
      stateLoader: state => state.loader,
      agentView: state => state.agentView
    }),
    ...mapState(USER_MODULE_NAME, {
      stateUserRoutes: 'routes'
    })
  },
  methods: {
    handleResolutionModal() {
      if (!this.$refs.minResolutionModal) return
      const minResolutionModal = this.$refs.minResolutionModal
      minResolutionModal.$data.showModal = window.innerWidth <= 1024
    },
    matchLocale: function(locale) {
      const locales = this.$i18n.availableLocales

      if (locales.length > 0) {
        return locales.indexOf(locale) !== -1 ? locale : locales[0]
      }

      return null
    },
    initI18n: function() {
      const locale = this.matchLocale(Settings.getLocale())

      this.$i18n.locale = locale
      Settings.setLocale(locale)
    }
  },
  async beforeCreate() {
    await GoogleMaps.injectScript()
    let host = window.location.host
    let subdomain = host.split('.')[0]
    let maDomain = true
    document.title = 'MAValue'
    if (subdomain === 'mesdommages') {
      document.title = 'Mes Dommages'
      maDomain = false
    }

    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.getElementsByTagName('head')[0].appendChild(link)
    }
    if (!maDomain) {
      link.href = '/faviconMD.ico'
    }
  },
  async created() {
    await this.initAuth()
    this.initI18n()

    if (!this.FNOLFlow.isExecuting) {
      window.addEventListener('resize', this.handleResolutionModal)
    }
  },
  destroyed() {
    GoogleMaps.removeScript()
  }
}
